import { setCookie } from '@cian/utils/lib/browser/cookie';

export function setRegionCookies(regionId: number, mainTownId: number | null | undefined) {
  if (typeof window === 'undefined') {
    return;
  }
  setCookie('session_region_id', String(regionId), { secure: false });
  setCookie('session_main_town_region_id', String(mainTownId || regionId), { secure: false });
}
